import React from "react";
import ImageWithFallback from "./ImageWithFallback";
import ApiRequest, { baseurl } from "../Common/restservice";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { errorToast, successToast } from "../Common/showtoast";

function ContactGrid({ item, index,nomobile=false }) {
  const navigate = useNavigate();
  const AddToFavourites = async () => {
    let res = await ApiRequest(
      "AddtoWishList.asp",
      "POST",
      JSON.stringify({ profileid: item.viewedmemberid || item.loginmemberid }),
      { Authorization: localStorage.getItem("token") }
    );
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Token Expired") {
        localStorage.clear();
        navigate("/");
      }
      return;
    }
    successToast(res.message);
  };
  return (
    
          <tr>
            <td>
              <label class="custom-control form-checkbox">{index + 1}</label>
            </td>
            <td>
              <div class="media mt-0 mb-0">
                <div class="card-aside-img">
                  <Link
                    to={`/${
                      item.usertypecategory === "Individual"
                        ? "individual"
                        : "company"
                    }/${item.viewedmemberid  || item.loginmemberid}`}
                  ></Link>
                  <ImageWithFallback
                    style={{ width: 60, height: "auto" }}
                    src={baseurl + item.profileimageURL}
                    alt="img"
                  />
                  {/* <img src="../assets/images/products/h1.png" alt="img" /> */}
                </div>
                <div class="media-body">
                  <div class="card-item-desc ms-4 p-0 mt-2">
                    <Link
                      to={`/${
                        item.usertypecategory === "Individual"
                          ? "individual"
                          : "company"
                      }/${item.viewedmemberid  || item.loginmemberid}`}
                      class="text-dark"
                    >
                      <h4 class="font-weight-semibold">{item.fullname}</h4>
                    </Link>
                    <Link
                      to={`/${
                        item.usertypecategory === "Individual"
                          ? "individual"
                          : "company"
                      }/${item.viewedmemberid  || item.loginmemberid}`}
                    >
                      <i class="fa fa-clock-o me-1"></i>
                      {item.viewedDate}
                    </Link>
                  </div>
                </div>
              </div>
            </td>
            {
              !nomobile && <td>{item.mobile}</td>
            }
            <td>
              <button
                class="btn btn-pink btn-sm text-white"
                onClick={() => AddToFavourites()}
                title="Save to Favourites"
              >
                <i class="fa fa-heart-o"></i>
              </button>
              <Link
              title="View"
                class="btn btn-primary btn-sm text-white"
                to={`/${
                  item.usertypecategory === "Individual"
                    ? "individual"
                    : "company"
                }/${item.viewedmemberid || item.loginmemberid}`}
              >
                <i class="fa fa-eye"></i>
              </Link>
            </td>
          </tr>
    // <div className="card overflow-hidden">
    //   <div
    //     className="item-card9-img"
    //     style={{
    //       height: 200,
    //       alignItems: "center",
    //       display: "flex",
    //     }}
    //   >
    //     <ImageWithFallback
    //       src={baseurl + item.profilepic}
    //       alt="img"
    //       style={{height:'100%',objectFit:'contain'}}
    //       className="cover-image"
    //     />
    //   </div>
    //   <div className="item-card2-icons">
    //     <Link
    //       to={`/${
    //         item.usertypecategory === "Individual" ? "individual" : "company"
    //       }/${item.viewedmemberid}`}
    //       className="item-card2-icons-l bg-primary"
    //     >
    //       <i className="fa fa-eye"></i>
    //     </Link>
    //     <a
    //       href="#"
    //       onClick={(e) => e.preventDefault()}
    //       className="item-card2-icons-r bg-secondary"
    //     >
    //       <i className="fa fa fa-heart-o"></i>
    //     </a>
    //   </div>
    //   <div className="card-body pb-0">
    //     <div className="item-card2">
    //       <div className="item-card2-desc">
    //         <div className="item-card2-text">
    //           <Link
    //             to={`/${
    //               item.usertypecategory === "Individual"
    //                 ? "individual"
    //                 : "company"
    //             }/${item.viewedmemberid}`}
    //             className="text-dark"
    //           >
    //             <h4 className="mb-0">{item.fullname}</h4>
    //           </Link>
    //         </div>
    //         <div className="d-flex">
    //           <Link
    //             to={`/${
    //               item.usertypecategory === "Individual"
    //                 ? "individual"
    //                 : "company"
    //             }/${item.viewedmemberid}`}
    //           >
    //             <p className="pb-0 pt-0 mb-2 mt-2">
    //               <i className="fa fa-phone text-danger me-2"></i>
    //               {item.mobile}
    //             </p>
    //           </Link>
    //           <span className="ms-3 pb-0 pt-0 mb-2 mt-2">
    //             <i className="fa fa-calendar text-danger me-2"></i>
    //             {item.viewedDate}
    //           </span>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
}

export default ContactGrid;
